import React, { useEffect, useRef, useId } from 'react';
import { X } from 'lucide-react';
import styles from './SimpleModal.module.css';

export default function SimpleModal({ title, onClose, children }) {
  const dialog = useRef(null);
  const titleId = useId();
  useEffect(() => {
    const previous = document.activeElement;
    const overflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    dialog.current?.focus();
    return () => { document.body.style.overflow = overflow; previous?.focus(); };
  }, []);
  function keyboard(e) {
    if (e.key === 'Escape') { e.stopPropagation(); onClose(); }
    if (e.key !== 'Tab') return;
    const elements = [...dialog.current.querySelectorAll('a[href],button:not(:disabled),input:not(:disabled),select:not(:disabled),textarea:not(:disabled),[tabindex="0"]')].filter((el) => el.getClientRects().length);
    const first = elements[0], last = elements[elements.length - 1];
    if (!first) { e.preventDefault(); return; }
    if (e.shiftKey && (document.activeElement === first || document.activeElement === dialog.current)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  return <div className={styles.overlay} onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
    <div className={styles.content} role="dialog" aria-modal="true" aria-labelledby={titleId} tabIndex={-1} ref={dialog} onKeyDown={keyboard}>
      <div className={styles.header}><h2 className={styles.title} id={titleId}>{title}</h2><button type="button" className={styles.close} onClick={onClose} aria-label="Закрыть"><X size={22} /></button></div>
      <div className={styles.body}>{children}</div>
    </div>
  </div>;
}
